export default __webpack_public_path__ + "static/media/BG_orange_form.08567d81.png";